import React from 'react';
import styled, { css } from 'styled-components';

import { Button, Input, PillAction } from '@xsolla/ui-core';

import { SpaceBetweenBlock, VerticalCenterBlock } from '../../../styled';
import { VerticalSeparator } from '../../ui';

export const SearchBarWrapper = styled(SpaceBetweenBlock)`
  margin-bottom: 24px;
  flex-wrap: wrap;
  row-gap: 8px;
`;

export const PlatformFieldsWrapper = styled.div`
  margin-bottom: 24px;
`;

export const PlatformHeaderWrapper = styled(SpaceBetweenBlock)`
  margin-bottom: 16px;
`;

export const PlatformHeader = styled.h1`
  ${(props) => props.theme.typography.title};
`;

export const SelectButton = styled(Button)`
  font-weight: 700;
  min-width: 65px;
  margin-right: 20px;
`;

export const SocialModeSelectWrapper = styled.div`
  width: 195px;
  margin-right: 16px;
`;

export const SocialSearchInput = styled(Input)`
  width: 210px;
`;

export const RigthContentWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const hasSocialStyle = css`
  display: grid;
  grid-gap: 16px;
  grid-template-columns: repeat(auto-fill, minmax(248px, 1fr));
`;

const fetchingStyles = css`
  display: flex;
`;

export const CardWrapper = styled.div<{ isFetching: boolean }>`
  width: 100%;
  ${(props) => (props.isFetching ? fetchingStyles : hasSocialStyle)}
  justify-content: center;

  transition: height 0.2s;

  margin-bottom: 32px;
`;

export const ShowModeButtonWrapper = styled.div`
  text-align: center;
  margin-bottom: 6px;
`;

export const StyledPill = styled(PillAction)`
  height: 36px;
  padding: 10px 16px;
  line-height: 24px;
`;

export const PillContentWrapper = styled(VerticalCenterBlock)`
  gap: 4px;
  margin: 0 4px;
  height: 24px;
`;

export const StyledSeparator = styled((props) => <VerticalSeparator {...props} />)`
  margin-right: 2px;
`;

export const PillActionText = styled.p`
  margin-left: 3px;
  font-size: 14px;
  line-height: 24px;
  text-transform: none;
`;
